<template>
  <div style="width:100%;height:100%;position:relative">
    <div class="column-side">
      <DatabaseFormComp :dbList="dbList" ref="sourceForm"></DatabaseFormComp>
      <el-button @click="showSourceTable">加载数据库表</el-button>
      <el-button @click="countTables">统计表数据</el-button>
      <el-button @click="exportTables">导出到本地</el-button>
      <el-button @click="clearTableData">清空表数据</el-button>
      <div v-if="selectedTables.length>0" style="float:right">已选 {{selectedTables.length}} 张表</div>
      <el-table ref="sourceTable"
                :data="tables"
                style="width: 100%" height="calc(100% - 130px)"
                @row-click="handleClickTableRow"
                @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="name"
          label="表名"
        >
        </el-table-column>
        <el-table-column
          prop="cname"
          label="中文名"
        >
        </el-table-column>
        <el-table-column
          prop="count"
          label="数量"
          width="100"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="column-center">
      <div class="buttonCls">
        <el-button @click="tableTransfer" :loading="transfering">在线迁移》</el-button>
      </div>
    </div>
    <div class="column-side" style="float:right">
      <DatabaseFormComp :dbList="dbList" ref="targetForm"></DatabaseFormComp>
      <el-button >
        <el-upload
          style=""
          v-bind="importProps"
        >
          <div>本地导入</div>
        </el-upload>
      </el-button>
      <div style="padding-top:20px;height:300px;border-top:1px solid #ccc">

        <mw-code-edit lang="SQL" ref="sql" editorBackend="ace"></mw-code-edit>
      </div>
      <el-button @click="execSql">执行sql脚本</el-button>
      <div style="margin-top:20px;height:200px">
        <mw-code-edit :value='sqlResult' lang="javascript" editorBackend="ace" v-if="showSqlResult" ref="sqlResult"></mw-code-edit>
      </div>
    </div>
  </div>
</template>

<script>
  import DatabaseFormComp from './databaseFormComp'
  export default {
    name: "tableExporter",
    components:{
      DatabaseFormComp
    },
    data() {
      let me=this;
      return {
        dbList:[],
        targetDBConfig:{},
        tables:[],
        selectedTables:[],
        transfering:false,
        sql:"",
        showSqlResult:false,
        sqlResult:"",
        importProps: {
          action: '/cheetah/service/s:table.transfer.srv.importSqlData',
          autoUpload: true,
          showFileList: false,
          data:{},
          beforeUpload(){
            let dbConfig=me.$refs.targetForm.getDBConfig();
            if(!dbConfig){
              PF.alert("请在右边配置要导入的数据库");
              return false
            }
            this.data.jsonData=JSON.stringify({dbConfig});
          },
          onSuccess: async (response) => {
            if (response && response.success) {
              PF.alert("导入成功")
            } else {
              PF.alert(response && response.msg || '导入失败')
            }
          },
          onError: (err, file, fileList) => {
            PF.alert("导入失败")
          }
        }
      }
    },
    mounted(){
      //this.loadDBList();
    },
    methods:{
      loadDBList(){
        PF.fsrv('tenant.srv.listDatabase',{}).then(r=>{
          let l=[{id:"[PlatformDatabase]",name:"平台数据库"}];
          this.dbList=l.concat(r.result)
        });
      },
      showSourceTable(){
        let dbConfig=this.$refs.sourceForm.getDBConfig();
        PF.fsrv("table.transfer.srv.listAllTable", dbConfig).then(r=>{
          if(r.success){
            r.result.forEach(t=>t.count='<未统计>')
            this.tables=r.result;
          }else{
            this.table=[]
          }
        });
      },
      handleSelectionChange(val) {
        this.selectedTables = val;
      },
      handleClickTableRow(row, event, column) {
        this.$refs.sourceTable.toggleRowSelection(row);
      },
      exportTables(){
        const tables=this.selectedTables.map(t=>t.name).sort();
        if(tables.length===0)return PF.message("请选择要导出的表")
        let dbConfig=this.$refs.sourceForm.getDBConfig();
        let params={
          dbConfig,tables
        }
        PF.downloadAttachment('/cheetah/service/s:table.transfer.srv.exportTableData', {}, undefined, JSON.stringify(params));
      },
      tableTransfer(){
        const tables=this.selectedTables.map(t=>t.name).sort();
        if(tables.length===0)return PF.message("请选择要导出的表")
        let fromDB=this.$refs.sourceForm.getDBConfig();
        let toDB=this.$refs.targetForm.getDBConfig();
        let params={
          tables,fromDB,toDB
        }
        this.transfering=true;
        PF.fsrv("table.transfer.srv.transferData", params).then(r=>{
          this.transfering=false;
          PF.alert("导入完成。");
        }).catch(r=>{
          PF.alert("导入失败")
          this.transfering=false;
        });
      },
      execSql(){
        let dbConfig=this.$refs.targetForm.getDBConfig();
        let params={
          dbConfig,
          sql:this.$refs.sql.getValue()
        };
        this.sqlResult="";
        this.showSqlResult=false;
        PF.fsrv("table.transfer.srv.executeStatement", params).then(r=>{
          this.showSqlResult=true;
          if(r.success){
            this.sqlResult=JSON.stringify(r.result || null)
          }else{
            this.sqlResult=r.msg
          }
        });
      },
      clearTableData(){
        const tables=this.selectedTables.map(t=>t.name).sort();
        if(tables.length===0)return PF.message("请选择要清空的表")
        let dbConfig=this.$refs.sourceForm.getDBConfig();
        let params={
          dbConfig,tables
        };
        PF.confirm('确定要清空表数据?请确认备份好有用的数据。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          PF.fsrv('table.transfer.srv.clearTableData', params).then(() => {
            this.countTables();
            PF.alert("清空完成")
          });
        }).catch(()=>{})
      },
      countTables(){
        const tables=this.selectedTables.map(t=>t.name).sort();
        if(tables.length===0)return PF.message("请选择要统计的表")
        let dbConfig=this.$refs.sourceForm.getDBConfig();
        let params={
          dbConfig,tables
        };
        PF.fsrv('table.transfer.srv.countTables', params).then((r) => {
          this.tables.forEach(t=>{
            if(r.success){
              let m=r.result
              if(m[t.name]!==undefined){
                t.count=m[t.name];
              }
            }
          })
        });
      }
    }
  }
</script>

<style scoped>
  .column-side{
    height:100%;
    width:calc(50% - 50px);
    padding:10px;
    border:1px solid #ccc;
    float:left;
    overflow: auto;
  }
  .column-center{
    height:100%;
    width:100px;
    float:left;
    text-align: center;
  }
  .buttonCls{
    top: 50%;
    position: relative;
    transform:translateY(-50%);
  }
  .buttonCls > button:not(:first-child){
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/index/views/maintain/tableExporter.vue